import type { BlogPostMeta } from "@/blog/posts";
import type { Locale } from "./locale";

export const CATEGORY_LABELS: Record<Locale, Record<BlogPostMeta["category"], string>> = {
  en: {
    "Axles & Suspension": "Axles & Suspension",
    "Service & Repair": "Service & Repair",
    "Buyer Guides": "Buyer Guides",
    "Trailer Parts": "Trailer Parts",
  },
  es: {
    "Axles & Suspension": "Ejes y Suspensión",
    "Service & Repair": "Servicio y Reparación",
    "Buyer Guides": "Guías de Compra",
    "Trailer Parts": "Piezas para Remolque",
  },
};

/** Display date; Spanish formats from the ISO date (UTC to avoid SSR drift). */
export function formatPostDate(post: Pick<BlogPostMeta, "date" | "dateIso">, locale: Locale): string {
  if (locale === "en") return post.date;
  return new Intl.DateTimeFormat("es-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  }).format(new Date(`${post.dateIso}T00:00:00Z`));
}
